import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FeaturedVideoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"featured_video"}/>
}
